export const products = [
  {
    id: 'prd_saas_impl',
    organizationId: 'org_3la_labs',
    name: 'Implantação de SaaS',
    type: 'Serviço',
    category: 'Consultoria',
    price: 8500,
    cost: 2200,
    margin: 74.1,
    status: 'Ativo',
  },
  {
    id: 'prd_suporte',
    organizationId: 'org_3la_labs',
    name: 'Suporte mensal',
    type: 'Serviço',
    category: 'Serviços',
    price: 1500,
    cost: 450,
    margin: 70,
    status: 'Ativo',
  },
  {
    id: 'prd_dev_hora',
    organizationId: 'org_3la_labs',
    name: 'Desenvolvimento sob demanda',
    type: 'Serviço',
    category: 'Serviços',
    price: 180,
    cost: 70,
    margin: 61.1,
    status: 'Ativo',
  },
  {
    id: 'prd_licenca',
    organizationId: 'org_3la_labs',
    name: 'Licença 3LA Manager',
    type: 'Produto',
    category: 'Produtos',
    price: 299,
    cost: 40,
    margin: 86.6,
    status: 'Ativo',
  },
  {
    id: 'prd_treinamento',
    organizationId: 'org_3la_labs',
    name: 'Treinamento operacional',
    type: 'Serviço',
    category: 'Consultoria',
    price: 2500,
    cost: 800,
    margin: 68,
    status: 'Ativo',
  },
  {
    id: 'prd_legacy',
    organizationId: 'org_3la_labs',
    name: 'Pacote legado starter',
    type: 'Produto',
    category: 'Produtos',
    price: 99,
    cost: 25,
    margin: 74.7,
    status: 'Inativo',
  },
];
